import React from 'react';
import { Typography } from '@mui/material';
import { sizes } from '../../styles/commonStyles';
import { useWorkflowTypes } from '../WorkflowsPage/hooks/useWorkflowTypes';

const NodHeaderAndSummary: React.FC<{ type: string }> = ({ type }) => {
  const { workflowTypes } = useWorkflowTypes();
  return (
    <Typography
      color="text.secondary"
      sx={{
        fontStyle: 'italic !important',
        letterSpacing: sizes.letterSpacing.wide,
        mb: 2,
        mt: 0,
        textAlign: 'center',
      }}
      variant="body2"
    >
      {workflowTypes.find((wt) => wt.value === type)?.description || ''}
    </Typography>
  );
};

export default NodHeaderAndSummary;
